module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-mini-calc-icons"
  }, [_c('svg', {
    staticStyle: {
      "position": "absolute"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "0",
      "height": "0"
    }
  }, [_c('defs', [_c('svg', {
    attrs: {
      "id": "back",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M90.2 42.4H8.5l17.2-19.3c1.1-1.2 1-3.2-.2-4.3-1.2-1.1-3.2-1-4.3.2L1.8 40.7c-2.4 2.6-2.4 6.6 0 9.3l19.4 21.7c.6.7 1.4 1 2.3 1 .7 0 1.4-.3 2-.8 1.2-1.1 1.4-3 .2-4.3L8.5 48.4h81.7c13.1 0 23.7 10.7 23.7 23.7s-10.7 23.7-23.7 23.7H75.8c-1.7 0-3 1.4-3 3s1.4 3 3 3h14.4c16.4 0 29.8-13.4 29.8-29.8 0-16.3-13.4-29.6-29.8-29.6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "close",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M1.3 118.7c-1.7-1.7-1.7-4.6 0-6.3L112.4 1.3c1.7-1.7 4.6-1.7 6.3 0 1.7 1.7 1.7 4.6 0 6.3L7.6 118.7c-1.7 1.7-4.6 1.7-6.3 0z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M112.4 118.7L1.3 7.6C-.4 5.9-.4 3 1.3 1.3s4.6-1.7 6.3 0l111.1 111.1c1.7 1.7 1.7 4.6 0 6.3s-4.6 1.7-6.3 0z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "delete",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M109.1 11.3H76.9V5.6c0-3.1-2.5-5.6-5.6-5.6H48.8c-3.1 0-5.6 2.5-5.6 5.6v5.7H10.9c-1.6 0-2.8 1.3-2.8 2.8 0 1.5 1.3 2.8 2.8 2.8h5.2l3.6 92.9c.2 5.7 4.9 10.1 10.5 10.1h59.5c5.7 0 10.3-4.5 10.5-10.1l3.6-92.9h5.2c1.6 0 2.8-1.3 2.8-2.8.1-1.5-1.2-2.8-2.7-2.8zM48.8 5.6h22.4v5.6H48.8V5.6zm45.9 104c-.1 2.6-2.3 4.7-4.9 4.7H30.3c-2.6 0-4.8-2.1-4.9-4.7l-3.6-92.7h76.4l-3.5 92.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M42.8 42.6c0-1.5-1.3-2.8-2.8-2.8-1.6 0-2.8 1.3-2.8 2.9l.9 46.1c0 1.5 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.9l-.9-46.1zM60 39.8c-1.6 0-2.8 1.3-2.8 2.8v46.1c0 1.6 1.3 2.8 2.8 2.8 1.6 0 2.8-1.3 2.8-2.8V42.6c0-1.6-1.2-2.8-2.8-2.8zM80.1 39.8c-1.5 0-2.9 1.2-2.9 2.8l-.9 46.1c0 1.6 1.2 2.8 2.8 2.9 1.5 0 2.8-1.2 2.8-2.8l.9-46.1c.1-1.6-1.1-2.9-2.7-2.9z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "edit",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M16.3 120l-5.4-31.5 59-83.1c2-2.8 4.9-4.6 8.3-5.2 3.4-.6 6.7.2 9.5 2.2l16.2 11.5c2.8 2 4.6 4.9 5.2 8.3.6 3.4-.2 6.7-2.2 9.5l-59 83.1-31.6 5.2zm1.6-29.9l3.8 22.3 22.3-3.8 57.4-80.9c.9-1.3 1.3-2.9 1-4.6-.3-1.6-1.2-3-2.5-4L83.8 7.7c-1.3-.9-2.9-1.3-4.6-1-1.6.3-3 1.2-4 2.5L17.9 90.1z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "filter",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M60 120c-9.4 0-16.5-4-16.5-9.2V75.3L0 31.6V20C0 7 30.9 0 60 0s60 7.1 60 20.2v11.6L76.5 75.3v35.5c0 5.2-7.1 9.2-16.5 9.2zM3.9 30l43.5 43.7v37.1c0 2.5 5.4 5.3 12.6 5.3s12.6-2.8 12.6-5.3V73.7l43.5-43.5v-10C116.1 12.5 93 3.9 60 3.9S3.9 12.4 3.9 20v10z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M59.9 37.3c-13 0-25.3-1.6-34.6-4.4-4.5-1.3-8.3-2.9-10.9-4.5-1.8-1.1-2.8-2.1-3.3-2.6L10 24.7l.9-1.3c.6-.9 1.9-2 3.6-3 2.7-1.6 6.4-3.1 10.8-4.5 9.9-2.8 22.2-4.4 34.6-4.4 13 0 25.3 1.6 34.6 4.4 4.5 1.3 8.3 2.9 10.9 4.5 1.8 1.1 2.8 2.1 3.3 2.6l1.4 1.4-1.4 1.4c-.5.5-1.5 1.5-3.3 2.6-2.7 1.6-6.4 3.2-10.8 4.5-10 2.9-22.3 4.4-34.7 4.4zM15.4 24.4c.3.2.7.5 1.1.8 2.2 1.4 5.7 2.9 9.9 4.1 9 2.7 20.9 4.2 33.5 4.2 12.1 0 24-1.5 33.5-4.2 4.1-1.3 7.5-2.7 9.9-4.1.4-.2.7-.5 1-.7-.3-.2-.7-.5-1.1-.7-2.2-1.4-5.7-2.9-9.9-4.1-9-2.7-20.9-4.2-33.5-4.2-12.1 0-24 1.5-33.5 4.2-4.1 1.3-7.5 2.7-9.9 4.1-.4.2-.7.4-1 .6z"
    }
  })]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "print",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.4 39.6H22.6V.3h74.8v39.3zm-69.8-4.9h64.9V5.3H27.6v29.4z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M99.2 108.3h-6.7V73H27.6v35.3h-6.7C9.3 108.3 0 99 0 87.5v-32C0 44 9.3 34.7 20.8 34.7h78.4c11.5 0 20.8 9.3 20.8 20.8v32c0 11.5-9.3 20.8-20.8 20.8zm-1.8-4.9h1.8c8.8 0 15.9-7.1 15.9-15.9v-32c0-8.8-7.1-15.9-15.9-15.9H20.8c-8.8 0-15.9 7.1-15.9 15.9v32c0 8.8 7.1 15.9 15.9 15.9h1.8V68.1h74.8v35.3z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M2.5 56h115.1v4.9H2.5zM97.4 119.7H22.6V68.1h74.8v51.6zm-69.8-5h64.9V73H27.6v41.7z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M85 90.4H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h50c1.4 0 2.5 1.1 2.5 2.5s-1.2 2.5-2.5 2.5zM63.2 102.3H35c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h28.1c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.4 2.5z"
    }
  }), _c('g', [_c('circle', {
    staticClass: "st0",
    attrs: {
      "cx": "94",
      "cy": "47.9",
      "r": "3.8"
    }
  })])]), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "download",
      "viewBox": "0 0 120 120",
      "width": "120",
      "height": "120"
    }
  }, [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M88.4 69.5c-1.2-1.3-3.2-1.5-4.6-.3L63.2 87.6v-84c0-1.8-1.4-3.2-3.2-3.2-1.8 0-3.2 1.4-3.2 3.2v84L36.1 69.2c-1.3-1.2-3.4-1.1-4.6.3-1.2 1.3-1.1 3.4.3 4.6L55 94.8c2.8 2.5 7.1 2.5 9.9 0L88.2 74c.7-.6 1.1-1.5 1.1-2.4 0-.7-.3-1.5-.9-2.1z"
    }
  }), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M97.5 119.6h-75C10.1 119.6 0 109.5 0 97.1V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c0 8.8 7.2 16 16 16h75.1c8.8 0 16-7.2 16-16V71.5c0-1.8 1.4-3.2 3.2-3.2s3.2 1.4 3.2 3.2v25.7c.1 12.3-10 22.4-22.4 22.4z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c495059e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/Icons.vue
// module id = 1805
// module chunks = 0